export const Types = {
    ADD: "ADD",
    REMOVE: "REMOVE",
    CLEAR:"CLEAR",
    REMOVEMULTI:"REMOVEMULTI",
    EMPADD:"EMPADD",
    EMPREMOVE: "EMPREMOVE",
    EMPCLEAR:"EMPCLEAR",
    EMPREMOVEMULTI:"EMPREMOVEMULTI",
};